<template>
  <div style="margin: 20px 0 8px">
    <div :class="$style.payWrapper" @click="openCardModal">
      <div :class="$style.left">
        <div :class="$style.inputLabel">{{ $t('cards.trade.pay_with') }}</div>
        <div v-if="cardList.length && currentCard" :class="$style.cardLine">
          <!-- icon -->
          <div :class="$style.cardIcon">
            <img
              :src="
                Number(currentCard.cardType) === CardType.VISA ? availableCardIssuerIcon1 : availableCardIssuerIcon2
              "
              alt="Card Icon"
            />
          </div>
          <div style="flex: 1">{{ currentCard?.cardNumber }}</div>
          <el-icon><ArrowRight /></el-icon>
          <!-- 箭头 -->
        </div>
        <div v-else :class="$style.cardLine" style="gap: 8px">
          <img :src="availableCardIssuerIcon2" alt="Card Icon" />
          <img :src="availableCardIssuerIcon1" alt="Card Icon" />
          <div style="font-size: 12px">Visa / Mastercard</div>
        </div>
      </div>
      <!-- last in space between -->
      <div v-if="!cardList?.length">
        <el-button type="primary" link :class="$style.addCardBtn">
          <el-icon size="10"><Plus /></el-icon>
          <span>{{ $t('cards.home.add_card') }}</span>
        </el-button>
      </div>
    </div>

    <!-- <ClientOnly>
      <CardHolderForm
        :visible="addCardModalVisible"
        :currency="currency"
        :channel-type="channelType"
        :add-card-form-value="props.addCardFormValue"
        :card-id="props.cardId"
        @update:visible="(v: boolean) => emits('update:cardHolderVisble',v)"
      ></CardHolderForm>
    </ClientOnly> -->
    <ClientOnly>
      <payment-cards-list
        :visible="cardListModalVisible"
        :card-id="props.cardId"
        :card-list="cardList"
        :bind-limit="bindLimit"
        @update:visible="(v: boolean) => (cardListModalVisible = v)"
        @after-delete="afterDeleteCard"
        @open-add-card="openAddCardModal"
        @update:card-id="(id: number) => emits('update:cardId', id)"
      ></payment-cards-list>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
// import { ElMessage } from 'element-plus';
import { Plus, ArrowRight } from '@element-plus/icons-vue';
import { CardType } from '~/utils/cards/type';
import { queryCards_post, type CardI } from '~/api/cards/trade';
// import CardHolderForm from './card-holder-form.vue';
import paymentCardsList from './payment-cards-list.vue';
import availableCardIssuerIcon1 from '@/assets/img/cards/card-issuer-visa-icon.svg?url';
import availableCardIssuerIcon2 from '@/assets/img/cards/card-issuer-master-icon.svg?url';
import { useCardsStore } from '~/store/cards';

const cardsStore = useCardsStore();
const props = defineProps(['channelType', 'cardId', 'currency', 'userInfo', 'addCardFormValue']);

const emits = defineEmits(['update:cardId', 'update:cardHolderVisble']);

const cardList = ref([] as CardI[]);
const bindLimit = ref(3);

const currentCard = computed(() => {
  return cardList.value.find((card) => card.cardId === props.cardId);
});

const cardListModalVisible = ref(false);
// const addCardModalVisible = ref(false);

const { start: startTimer, stop: destroyTimer } = useCountdown({
  action: queryCards,
  duration: 5 * 1000, // 5s查询一次绑定状态
  loop: true,
});

// 打开添加卡片模态框的方法
const openCardModal = async () => {
  if (cardList?.value.length) {
    cardListModalVisible.value = true;
  } else {
    openAddCardModal();
  }
};

const openAddCardModal = async () => {
  // const userInfo = await cardsStore.getUserInfo();
  // console.log('========== userInfo:', userInfo);
  // kycAuditResult forbidden 需要kyc
  // if(userInfo.accountTypeCheckResult === 'forbidden' ){
  //   indexStore.SHOW_KYC_COUNTRY_LIMIT_DIALOG_WIDTH_DATA({
  //     countryCodeList: userInfo?.forbiddenCountries || [],
  //   });
  //   return;
  // }
  // if(userInfo.kycAuditResult === 'forbidden'){
  // indexStore.SHOW_KYC_COUNTRY_LIMIT_DIALOG_WIDTH_DATA({
  //   countryCodeList: userInfo?.forbiddenCountries || [],
  // });
  // return;
  // }
  // 如果没有userName 提示 Verification required

  const needVerified = await cardsStore.openPreValidation();
  if (needVerified) {
    return;
  }
  emits('update:cardHolderVisble',true);
  // addCardModalVisible.value = true;
  cardListModalVisible.value = false;
};

const afterDeleteCard = (deleteId?: string|number) => {
  // 先删除cardList中id为deleteId的卡片 只过滤第一条 
  const newList = cardList.value.filter((card) => card.cardId!== deleteId);
  
  if (!newList.length) {
    emits('update:cardId', '');
    cardListModalVisible.value = false;
  }
  queryCards().then((res:any)=>{
    // 如果删除的卡是原先选中的卡 那么也重置
    if (deleteId === props.cardId) {
      emits('update:cardId', res?.data?.cardList?.[0]?.cardId || '');
    }
  });
  
};

// const intervalId = ref();

function queryCards() {
  if (!props.channelType) {
    return Promise.resolve({});
  }
  return queryCards_post({
    data: {
      channelType: props.channelType,
    },
  }).then((res) => {
    cardList.value = res?.data?.cardList ?? [];
    bindLimit.value = res.data?.bindLimit ?? 3;
    if (!res?.data?.existBindingCard) {
      destroyTimer();
    } else {
      destroyTimer();
      startTimer();
    }
    return res;
  });
}

// 初始化监听
watch([() => props.cardId, cardList],
  ([newCardId]) => {
    console.log("初始化监听");
    if (!newCardId && cardList.value.length) {
      emits('update:cardId', cardList.value[0]?.cardId);
    }
  },
  { immediate: true }
);



/**
 * 初始化
 * channelType 从后端获取值时，取消immediate
 */
watch(
  () => props.channelType,
  () => {
    queryCards();

  },
  { immediate: true }
);

onUnmounted(() => {
  destroyTimer();
});
</script>

<style lang="css" module>
.payWrapper {
  display: flex;
  align-items: center;
  margin-top: 10px;
  justify-content: space-between;
  height: 72px;
  padding: 16px;
  background-color: #eff4f6;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
}

.inputLabel {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}
.left {
  flex: 1;
}
.cardLine {
  display: flex;
  align-items: center;
  .cardIcon {
    height: 20px;
    margin-right: 6px;
  }
}
.addCardBtn{
  &:focus{
    color: var(--brand-color) !important;
  }
}
</style>
